export default "/Resources/1cd0815e03afc6847d40cb6a08b3d8c3.svg";